/**
 * Defines all creation sources.
 */
export enum CreationSources {
  DASHBOARD = 1,
}
